import React, { useEffect, useState, useContext } from 'react'
import SearchTable from 'src/components/searchTable'
import { CFormSwitch } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import { activeArray, checkPermissions, raiseToast } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import UserGroupModal from './UserGroupModal'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import { ROLE_LIST_API, USER_API } from '../../../utils/urls'
import { AppContext } from '../../../context/app'

const UserGroupList = () => {
  const { userObj } = useContext(GlobalContext)
  const { setLoader } = useContext(AppContext)

  const [rolesList, setRolesList] = useState([])
  const [usersList, setUsersList] = useState([])
  const [userGroup, setUserGroup] = useState([])
  const [selectedGroup, setSelectedGroup] = useState({})

  const [openModal, setOpenModal] = useState(false)

  const { userSessionObj } = useContext(GlobalContext)

  const createAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.USER_MANAGEMENT.CREATE,
  )
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.USER_MANAGEMENT.UPDATE,
  )

  const [{ data: userGroupList, loading: userGroupListLoading }, userGroupListCall] = useAxios(
    {
      url: `${USER_API}/user-group`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: roleList, loading: roleListLoading }, roleListListCall] = useAxios(
    {
      url: ROLE_LIST_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: cmsUserList, loading: cmsUserListLoading }] = useAxios({
    url: `${USER_API}/cms-user`,
    method: 'get',
  })

  const [{ data: createUserGroup, loading: createUserGroupLoading }, createUserGroupCall] =
    useAxios(
      {
        url: `${USER_API}/user-group`,
        method: 'post',
      },
      { manual: true },
    )

  const [{ data: updateUserGroup, loading: updateUserGroupLoading }, updateUserGroupCall] =
    useAxios(
      {
        url: `${USER_API}/user-group`,
        method: 'put',
      },
      { manual: true },
    )

  useEffect(() => {
    roleListListCall()
    userGroupListCall()
  }, [])

  useEffect(() => {
    setLoader(
      roleListLoading || cmsUserListLoading || userGroupListLoading || createUserGroupLoading,
      updateUserGroupLoading,
    )
  }, [
    roleListLoading,
    cmsUserListLoading,
    userGroupListLoading,
    createUserGroupLoading,
    updateUserGroupLoading,
  ])

  useEffect(() => {
    if (userGroupList && userGroupList.success && roleList && roleList.success) {
      let tempGroups = []
      let tempArr = roleList.data.filter(
        (ele) => ele.name !== 'subscriber' && ele.name !== 'Account Admin',
      )
      userGroupList.data.forEach((ele) => {
        let roleString = ''
        let { roles } = ele

        roles.forEach((element, index) => {
          const roleObj = roleList.data.find((role) => role._id === element)
          if (roleObj) {
            roleString += `${roleObj.name}${index < roles.length - 1 ? ',' : ''} `
          }
        })

        tempGroups.push({ ...ele, roleName: roleString })
      })
      setUserGroup(tempGroups)
      setRolesList(activeArray(tempArr))
    }
  }, [roleList, userGroupList])

  useEffect(() => {
    if (cmsUserList && cmsUserList.success) {
      let tempArr = cmsUserList.data.filter((ele) => ele._id !== userObj._id)
      setUsersList(activeArray(tempArr))
    }
  }, [cmsUserList])

  useEffect(() => {
    if (createUserGroup && createUserGroup.success) {
      userGroupListCall()
      raiseToast('success', 'User Group created successfully')
    }
  }, [createUserGroup])

  useEffect(() => {
    if (updateUserGroup && updateUserGroup.success) {
      userGroupListCall()
      raiseToast('success', 'User Group updated successfully')
    }
  }, [updateUserGroup])

  const handleStatus = async (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }

    updateUserGroupCall({
      params: {
        user_group_id: info._id,
      },
      data: {
        status: !info.status,
      },
    })
  }

  const handleEdit = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }

    setSelectedGroup(info)
    setOpenModal(true)
  }
  const handleAdd = () => {
    if (!createAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedGroup({})
    setOpenModal(!openModal)
  }

  const addUserGroup = (payload) => {
    createUserGroupCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editUserGroup = (payload, id) => {
    updateUserGroupCall({
      params: {
        user_group_id: id,
      },
      data: payload,
    })
    setOpenModal(false)
  }
  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 17,
    },
    {
      header: 'Description',
      dataCell: (info) => info.description,
      width: 20,
    },
    {
      header: 'roles',
      dataCell: (info) => info.roleName,
      width: 25,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 13,
    },
    {
      header: 'Status',
      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 13,
    },

    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 7,
    },
  ]
  return (
    <>
      <h4>User Groups</h4>
      <p>{`Manage your User Groups`}</p>
      <SearchTable
        type={`User Group`}
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ Add User Group`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableContent={userGroup}
        tableConfig={tableConfig}
        createPermission={createAllowed}
      />
      {openModal && (
        <UserGroupModal
          openModal={openModal}
          onCancel={() => setOpenModal(false)}
          roleData={rolesList}
          userData={usersList}
          groupData={selectedGroup}
          addCallback={addUserGroup}
          editCallback={editUserGroup}
        />
      )}
    </>
  )
}

export default UserGroupList
